module.exports = __webpack_public_path__ + "static/media/boss-logo.2925ad86.png";